<div class="d-flex justify-content-between align-items-center matDialogBorderBottom">
    <h4 class="matDialogTitle" mat-dialog-title [textContent]="title"></h4>
    <span class="material-icons mb-1" mat-dialog-close>close</span>
</div>
<mat-dialog-content align="center" class="mat-typography" [innerHTML]="message"></mat-dialog-content>
<mat-dialog-actions align="center" class="matDialogFooter noBorder">
    <material-button class="!mx-2" *ngIf="btnCancelText" [text]="btnCancelText" (buttonClicked)="decline()"></material-button>
    <material-button class="!mx-2" [text]="btnOkText" [color]="'primary'" (buttonClicked)="accept()"></material-button>
</mat-dialog-actions>
